import { Link } from "react-router-dom";
import { Mic2, ArrowRight } from "lucide-react";

export default function DailyPromo() {
  return (
    <div className="max-w-xl mx-auto px-4 py-16 sm:py-24 text-center" data-testid="promo-coming-soon">
      <div className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-red-500 mb-3">
        <Mic2 className="h-4 w-4" /> Daily Promo
      </div>
      <h1 className="font-display text-5xl sm:text-7xl font-black uppercase leading-none tracking-tight">
        <span className="text-white">Coming</span><br />
        <span className="text-red-500 drop-shadow-[0_0_25px_rgba(220,38,38,0.45)]">Soon</span>
      </h1>
      <p className="mt-6 text-slate-400 max-w-md mx-auto">
        Identify the Voice is still cutting its debut promo. In the meantime, the Entrance Theme
        arena is open for business.
      </p>
      <Link to="/daily/theme"
        className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-red-600 hover:bg-red-500 text-white font-bold uppercase tracking-wide rounded-xl"
        data-testid="promo-goto-theme">
        Play Today's Theme <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
